import * as React from 'react';
import * as styles from './styles.scss';
import { getDropViewState } from '../viewstate';
import { canDropAsset, onDropAsset } from '../util/assetDragAndDrop';
import { Droppable } from 'owa-dnd';
import { observer } from 'mobx-react-lite';
import TimeStreamDocumentPanningLayer from './TimeStreamDocumentPanningLayer';

export default observer(function TimeStreamDocumentLayer() {
    return (
        <Droppable
            canDrop={canDropAsset}
            onDrop={onDropAsset}
            dropViewState={getDropViewState()}
            classNames={styles.canvasDroppable}>
            <TimeStreamDocumentPanningLayer />
        </Droppable>
    );
});
